import axios from 'axios'

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:4000/api/v1',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Request interceptor
api.interceptors.request.use(
    (config) => {
        // Add language header
        const language = localStorage.getItem('language') || 'fr'
        config.headers['Accept-Language'] = language

        return config
    },
    (error) => Promise.reject(error)
)

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config

        // Don't intercept auth routes - let them handle their own errors
        const isAuthRoute = originalRequest.url?.includes('/auth/login') ||
            originalRequest.url?.includes('/auth/refresh')

        if (isAuthRoute) {
            return Promise.reject(error)
        }

        // Handle 401 errors (token expired) for non-auth routes only
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true

            // Try to refresh token
            const refreshToken = JSON.parse(localStorage.getItem('auth-storage') || '{}')?.state?.refreshToken

            if (refreshToken) {
                try {
                    const response = await axios.post(
                        `${import.meta.env.VITE_API_URL}/auth/refresh`,
                        { refreshToken }
                    )

                    const { accessToken, refreshToken: newRefreshToken } = response.data.data

                    // Update stored tokens
                    const storage = JSON.parse(localStorage.getItem('auth-storage') || '{}')
                    storage.state = {
                        ...storage.state,
                        accessToken,
                        refreshToken: newRefreshToken
                    }
                    localStorage.setItem('auth-storage', JSON.stringify(storage))

                    // Update header and retry
                    api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
                    originalRequest.headers['Authorization'] = `Bearer ${accessToken}`

                    return api(originalRequest)
                } catch (refreshError) {
                    // Clear auth on refresh failure
                    localStorage.removeItem('auth-storage')
                    delete api.defaults.headers.common['Authorization']
                    window.location.href = '/login'
                    return Promise.reject(refreshError)
                }
            }

            // No refresh token, redirect to login
            localStorage.removeItem('auth-storage')
            delete api.defaults.headers.common['Authorization']
            window.location.href = '/login'
        }

        return Promise.reject(error)
    }
)

export default api
